export enum ParameterizationTypeEnum {
  branch = "Unidade",
  team = "Tipo do Pacote",
  type = "Tipo do Evento",
}
